class BuildYourBandana extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      inputVariant: '[data-opt-choice]',
      letteringContainer: '[data-lettering-container]',
      threadContainer: '[data-thread-container]',
      nameContainer: '[data-name-container]',
    };
  }

  connectedCallback() {
    this.inputs = this.querySelectorAll(this.selectors.inputVariant);
    this.letteringContainer = this.querySelector(this.selectors.letteringContainer);
    this.threadContainer = this.querySelector(this.selectors.threadContainer);
    this.nameContainer = this.querySelector(this.selectors.nameContainer);

    if (this.inputs.length) {
      this.inputs.forEach(input => {
        input.addEventListener('change', () => this.toggleEmbroidery(input));
      });
    }
  }

  toggleEmbroidery(input) {
    if (input.id === 'byb-embroidery-yes' && input.checked) {
      this.showSection(this.letteringContainer);
      this.showSection(this.threadContainer);
      this.showSection(this.nameContainer);
    } else if (input.id === 'byb-embroidery-no' && input.checked) {
      this.hideSection(this.letteringContainer);
      this.hideSection(this.threadContainer);
      this.hideSection(this.nameContainer);
    }
  }

  showSection(section) {
    if (!section) return;
    section.classList.add('active');
    section.style.setProperty('--max-height', section.scrollHeight + 'px');
  }

  hideSection(section) {
    if (!section) return;
    section.classList.remove('active');
    section.style.setProperty('--max-height', '0px');
  }
}

customElements.define('build-your-bandana', BuildYourBandana);
